import { createSlice } from '@reduxjs/toolkit';
import { fetchCustomerId } from './actions';

interface ModelState {
  id: number | null;
  loading: boolean;
  error: Error | null;
  loaded: boolean;
}

const initialState = {
  id: null,
  loading: false,
  loaded: false,
  error: null,
} as ModelState;

export const getCustomerIdSlice = createSlice({
  name: 'getCustomerId',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCustomerId.request, state => {
      state.error = null;
      state.loading = true;
      state.loaded = false;
      state.id = null;
    });
    builder.addCase(fetchCustomerId.success, (state, { payload }) => {
      state.id = payload;
      state.loaded = true;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchCustomerId.failure, (state, { payload }) => {
      state.error = payload;
      state.id = null;
      state.loaded = true;
      state.loading = false;
    });
    builder.addCase(fetchCustomerId.cancel, state => {
      state.error = null;
      state.id = null;
      state.loading = false;
      state.loaded = false;
    });
  },
});

export default getCustomerIdSlice.reducer;
